import type {
  OverrideInterval,
  WorkingInterval,
} from "model/organizationCalendarModel";

export interface CalendarIntervalError {
  key: string;
  messageKey: string;
}

const TIME_PATTERN = /^(?:[01]\d|2[0-3]):[0-5]\d$/;

const minutes = (value: string) =>
  Number(value.slice(0, 2)) * 60 + Number(value.slice(3, 5));

export function validateIntervals(
  intervals: Array<WorkingInterval | OverrideInterval>,
  keyPrefix: string
): CalendarIntervalError[] {
  const errors: CalendarIntervalError[] = [];
  const valid = intervals
    .map((value, index) => ({ value, index }))
    .filter(({ value, index }) => {
      if (
        !TIME_PATTERN.test(value.startsAt) ||
        !TIME_PATTERN.test(value.endsAt)
      ) {
        errors.push({
          key: `${keyPrefix}-${index}`,
          messageKey: "calendar.interval.error.required",
        });
        return false;
      }
      if (minutes(value.startsAt) >= minutes(value.endsAt)) {
        errors.push({
          key: `${keyPrefix}-${index}`,
          messageKey: "calendar.interval.error.order",
        });
      }
      return true;
    })
    .sort((left, right) =>
      left.value.startsAt.localeCompare(right.value.startsAt)
    );

  for (let index = 1; index < valid.length; index += 1) {
    if (
      minutes(valid[index].value.startsAt) <
      minutes(valid[index - 1].value.endsAt)
    ) {
      errors.push({
        key: `${keyPrefix}-${valid[index].index}`,
        messageKey: "calendar.interval.error.overlap",
      });
    }
  }

  return errors;
}

export const validateWorkingIntervals = (intervals: WorkingInterval[]) =>
  ([1, 2, 3, 4, 5, 6, 7] as const).flatMap((day) =>
    validateIntervals(
      intervals.filter((interval) => interval.isoWeekday === day),
      `weekday-${day}`
    )
  );
